import { Route, Routes } from "react-router-dom";

import { AppShell } from "@/components/layout/AppShell";
import { RequireAuth } from "@/lib/auth/AuthProvider";
import { Landing } from "@/routes/Landing";
import { Session } from "@/routes/Session";

/**
 * Application root.
 *
 * Routes:
 *   /              - landing / "describe your integration"
 *   /sessions/:id  - live orchestration view (auth-gated)
 *   /history       - past deployments (Phase 3.8)
 *
 * Landing stays public so the marketing copy is visible without sign-in;
 * the orchestration view is gated behind RequireAuth because it calls the
 * API.
 */
export function App() {
  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route
          path="/sessions/:id"
          element={
            <RequireAuth>
              <Session />
            </RequireAuth>
          }
        />
      </Routes>
    </AppShell>
  );
}
